/** recharts constants shared by the dashboard charts (legacy landing page look). */
export const chartTheme = {
  grid: '#e2e8f0',
  tick: { fill: '#94a3b8', fontSize: 11 },
  axis: { fill: '#64748b', fontSize: 12 },
  bar: { fill: '#3182ce', radius: [4, 4, 0, 0] },
  line: { stroke: '#48bb78', strokeWidth: 2, dot: { fill: '#48bb78', strokeWidth: 0, r: 4 } },
  tooltip: { backgroundColor: '#1a365d', border: 'none', borderRadius: '8px', color: 'white' },
  colors: ['#3182ce', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#ec4899', '#14b8a6', '#f97316'],
};
